import { defineTokens } from '@chakra-ui/react';

import { colors } from './colors';
import { gradients } from './gradients';

export const tokens = defineTokens({
	...colors,
	...gradients,
});
